"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var confirmationMessageStyles = styles_1.makeStyles(function (theme) { return ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        verticalAlign: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        width: '100%',
        minHeight: 42,
    },
    title: {
        textTransform: 'uppercase',
        fontWeight: 'bold',
        alignSelf: 'center',
        color: theme.palette.common.black,
    },
    description1: {
        margin: '20px 0',
    },
    description2: {
        marginBottom: 40,
    },
    email: {},
}); }, { name: 'GqlCheckout_ConfirmationMessage' });
exports.default = confirmationMessageStyles;
